import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Crown from '../images/Crown.svg'
import Star1 from '../images/star1.svg'
import Star2 from '../images/star2.svg'
import Star3 from '../images/star3.svg'
import Academy from '../images/academy.svg'
import ChevronBack from '../images/chevron_left_white.svg'
import CircleExclamation from '../images/circle_exclamation.svg'
import EmptyStar from '../images/EmptyStar.svg'
import LeaderboardBg from '../images/leaderboard_bg.svg'
import ChevronRight from '../images/chevron_right_white.svg'
import { handleEventLog, numFormatter } from '../../../lib/utils'
import Fire from '../images/fire.svg'
import Trending from '../images/trending.svg'
import Clock from '../images/clock.svg'

const LeaderboardSection = styled.section`
  background: #0e4c95;
  width: 100%;
  font-family: 'Inter';
  padding: 20px 5px;
  position: relative;
  overflow: hidden;
`
const Heading = styled.div`
  font-weight: 600;
  font-size: 24px;
  text-align: center;
  color: #ffffff;
  width: 100%;
  height: 65px;
  font-family: 'Inter', sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`
const Tabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  height: 50px;
  width: 100%;
  font-family: 'Inter', sans-serif;
  position: relative;
`
const Tab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: ${({ active }) =>
    active ? 'rgba(255, 255, 255, 0.1)' : ''};
  border-radius: 30px;
  width: 110px;
  height: 46px;
  font-size: 18px;
  line-height: 22px;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  &:last-child{
    width: 140px;
  }
`
const TopNovels = styled.div`
  width: 100%;
  margin: 100px 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`
const NovelRank = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 7px;
  max-width: 26%;
`

const NovelRank3Img = styled.img`
  width: 80px;
  border-radius: 4px;
  @media screen and (max-width: 570px) {
    width: 60px;
  }
`
const NovelRank1Img = styled.img`
  width: 104px;
  border-radius: 4px;
  @media screen and (max-width: 570px) {
    width: 80px;
  }
`
const NovelRank2Img = styled.img`
  width: 80px;
  border-radius: 4px;
  @media screen and (max-width: 570px) {
    width: 60px;
  }
`

const CrownImg = styled.img`
  position: absolute;
  top: -90px;
  width: 100px;
  border-radius: 4px;
  @media screen and (max-width: 570px) {
    width: 80px;
    top: -70px;
  }
`
const Star3Img = styled.img`
  position: relative;
  top: -20px;
  width: 40px;
`
const Star1Img = styled.img`
  position: relative;
  top: -20px;
  width: 48px;
`
const Star2Img = styled.img`
  position: relative;
  top: -20px;
  width: 40px;
`
const AuthorName = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  @media screen and (max-width: 570px) {
    font-size: 14px;
  }
`
const NovelName = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  @media screen and (max-width: 570px) {
    font-size: 12px;
  }
`
const StatsDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 14px;
  width: 100%;
`
const WordsDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 15%;
  margin: 0 14px;
  h5 {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: white;
    @media screen and (max-width: 570px) {
      font-size: 12px;
    }
  }
  h6 {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: white;
    font-family: 'Inter', sans-serif;
    @media screen and (max-width: 570px) {
      font-size: 10px;
    }
  }
`
const ViewsDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 15%;
  margin: 0 14px;
  h5 {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: white;
    font-family: 'Inter', sans-serif;
    @media screen and (max-width: 570px) {
      font-size: 12px;
    }
  }
  h6 {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: white;
    font-family: 'Inter', sans-serif;
    @media screen and (max-width: 570px) {
      font-size: 10px;
    }
  }
`
const UserNovel = styled.div`
  background: rgba(6, 138, 226, 0.16);
  border: 1px solid rgba(6, 138, 226, 0.24);
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 96%;
  margin: auto;
  padding: 10px 0;
  position: relative;
`
const UserNovelImg = styled.img`
  width: 42px;
  box-shadow: 0px 4px 8px rgba(73, 83, 89, 0.16);
  border-radius: 2px;
  margin-right: 8px;
  @media screen and (max-width: 400px) {
    width: 34px;
  }
`
const UserNovelName = styled.div`
  width: 40%;
  flex: 1;
  @media screen and (max-width: 400px) {
    width: 30%;
  }
  h5 {
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #ffffff;
    @media screen and (max-width: 400px) {
      font-size: 12px;
    }
  }
  h6 {
    font-size: 12px;
    color: #ffffff;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    @media screen and (max-width: 400px) {
      font-size: 10px;
    }
  }
`

const NewTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33px;
  height: 19px;
  background: #f9c682;
  color: #6b4209;
  border-radius: 4px;
  font-weight: 700;
  font-size: 12px;
`
const SeeAllrankings = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  width: 100%;
  height: 60px;
  gap: 20px;
  position: relative;
  cursor: pointer;
`
const AllRankings = styled.div`
  font-family: 'Inter', sans-serif;
  width: 94%;
  background: #ffffff;
  border-radius: 8px;
  margin: auto;
  padding: 15px 0;
  position: relative;
`
const RankingTabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 94%;
  height: 40px;
  background: #0e4c95;
  border-radius: 8px;
  margin: auto;
  padding: 0 8px;
`
const RankingTab = styled.div`
  width: 33%;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  background: ${({ active }) => (active ? '#206CC6' : 'transparent')};
`
const SingleRank = styled.div`
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 90%;
  margin: auto;
  padding: 10px 0;
  background: ${({ myRank }) =>
    myRank ? 'rgba(6, 138, 226, 0.16)' : 'transparent'};
  border: ${({ myRank }) =>
    myRank ? '1px solid rgba(6, 138, 226, 0.24)' : 'none'};
`
const StarImg = styled.div`
  margin-right: 4px;
  position: relative;
  img {
    min-width: 26px;
  }
  p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: 'Poppins', 'Inter', sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #000000;
  }
`
const SingleRankDetails = styled.div`
  width: 40%;
  flex: 1;
  @media screen and (max-width: 400px) {
    width: 30%;
  }
  h5 {
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #0d1536;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media screen and (max-width: 400px) {
      font-size: 12px;
    }
  }
  h6 {
    font-size: 12px;
    color: #ffffff;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    color: rgba(13, 21, 54, 0.65);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media screen and (max-width: 400px) {
      font-size: 10px;
    }
  }
`
const SingleRankWords = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 15%;
  margin: 0 14px;
  h5 {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: rgba(13, 21, 54, 0.65);
    @media screen and (max-width: 400px) {
      font-size: 12px;
    }
  }
  h6 {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    font-family: 'Inter', sans-serif;
    color: rgba(13, 21, 54, 0.4);
    @media screen and (max-width: 400px) {
      font-size: 10px;
    }
  }
`
const SingleRankViews = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 15%;
  h5 {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: rgba(13, 21, 54, 0.65);
  }
  h6 {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    font-family: 'Inter', sans-serif;
    color: rgba(13, 21, 54, 0.4);
  }
`
const DisclaimerAndTips = styled.div`
  width: 94%;
  padding: 20px 20px 44px 20px;
  margin: 8px auto;
  background: #ffffff;
  border-radius: 8px;
`
const Disclaimer = styled.div`
  background: rgba(242, 198, 2, 0.4);
  border: 1px solid #f2c602;
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 14px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 16px;
  color: rgba(13, 21, 54, 0.65);
`
const DisclaimerHeading = styled.div`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: rgba(13, 21, 54, 0.65);
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 6px;
`
const Tips = styled.div`
  background: rgba(6, 138, 226, 0.16);
  border: 1px solid rgba(6, 138, 226, 0.24);
  border-radius: 4px;
  padding: 14px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 15px;
  color: rgba(13, 21, 54, 0.65);
`
const TipsHeading = styled.div`
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: rgba(13, 21, 54, 0.65);
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 6px;
`
const BackImg = styled.img`
  position: absolute;
  z-index: 3;
  width: 40px;
  height: 40px;
  left: 20px;
  top: 20px;
  background: #367bcc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
`
const LeaderboardBackground = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 700px;
  object-fit: cover;
`

const LeaderBoard = ({
  contestId,
  seeAllRankings,
  sectionMode,
  setLeaderboardOpen,
  leaderboardData,
  defaultLeaderboardTab,
  contestData
}) => {
  const [tab, setTab] = useState(defaultLeaderboardTab || 'popular')
  const [durationTab, setDurationTab] = useState('last_7_days')
  const [rankData, setRankData] = useState([])
  const [myRank, setMyRank] = useState({})

  useEffect(() => {
    if (leaderboardData.new && leaderboardData.popular) {
      if (tab === 'popular') {
        const data = leaderboardData?.popular[durationTab]
        if (data.top_10.length < 1) {
          const arr = data.top_10
          for (let i = data.top_10.length; i <= 10; i+=1) {
            arr.push({})
          }
          setRankData(arr)
        }
        setRankData(data.top_10 || [])
        if (data.my_rank) setMyRank(data.my_rank)
      }
      if (tab === 'new') {
        const data = leaderboardData?.new
        if (data.top_10.length < 1) {
          const arr = data.top_10
          for (let i = data.top_10.length; i <= 10; i+=1) {
            arr.push({})
          }
          setRankData(arr)
        }
        setRankData(data.top_10 || [])
        if (data.my_rank) setMyRank(data.my_rank)
      }
      if (tab === 'scheduled') {
        const data = leaderboardData?.scheduled
        if (data.top_10.length < 1) {
          const arr = data.top_10
          for (let i = data.top_10.length; i <= 10; i+=1) {
            arr.push({})
          }
          setRankData(arr)
        }
        setRankData(data.top_10 || [])
        if (data.my_rank) setMyRank(data.my_rank)
      }
    }
  }, [durationTab, tab, leaderboardData])

  const handleBookTitle = (title) => {
    let newTitle
    if (title.includes('।')) {
      newTitle = title.split('।')[0]
    } else {
      newTitle = title.split('|')[0]
    }
    if (newTitle.length > 30) {
      newTitle = newTitle.substring(0, 30) + '...'
    }
    return newTitle
  }

  const handleShowRank = (obj) => {
    if (tab === 'scheduled') return obj.all_time_rank_scheduled
    if (tab === 'new') return obj.all_time_rank_new
    if (tab === 'popular') {
      if (durationTab === 'last_7_days') return obj.last_7_final_rank_popular
      if (durationTab === 'last_30_days') return obj.last_30_final_rank_popular
      if (durationTab === 'all_time') return obj.all_time_rank_popular
    }
  }

  const handleSeeAllRanking = () => {
    handleEventLog(
      tab === 'popular'
        ? 'popular_leaderboard_module' :
        tab === 'new' ? 'new_leaderboard_module' : 'scheduled_leaderboard_module',
      'button_click',
      {
        module_name: 'See all rankings',
        entity_type: 'contest',
        entity_id: contestId,
      }
    )
    handleEventLog(
      tab === 'popular' ? 'popular_leaderboard' : tab === 'new' ? 'new_leaderboard_module' : 'scheduled_leaderboard_module',
      'page_load',
      {
        entity_type: 'contest',
        entity_id: contestId,
      }
    )
    setLeaderboardOpen(true)
  }

  const handleTabChange = (tb) => {
    setTab(tb)
    if (seeAllRankings) {
      handleEventLog(
        tb === 'popular' ? 'popular_leaderboard' :  tb === 'new' ? 'new_leaderboard' : 'scheduled_leaderboard',
        'page_load',
        {
          entity_type: 'contest',
          entity_id: contestId,
          module_name: tb === 'popular' ? durationTab : '',
        }
      )
    } else {
      handleEventLog(
        tb === 'popular'
          ? 'popular_leaderboard_module'
          : tb === 'new' ? 'new_leaderboard_module' : 'scheduled_leaderboard_module',
        'page_load',
        {
          entity_type: 'contest',
          entity_id: contestId,
        }
      )
    }
  }

  const handleDurationTabChange = (dt) => {
    setDurationTab(dt)
    handleEventLog('popular_leaderboard', 'page_load', {
      entity_type: 'contest',
      entity_id: contestId,
      module_name: dt,
    })
  }

  function HandleDisclaimerAndTips({ text }){
    if (!text) return <>To be Announced Shortly</>
    return <div dangerouslySetInnerHTML={{ __html: text.replace(/(?:\r\n|\r|\n)/g, '<br>') }} />
  }

  return (
    <LeaderboardSection>
      <LeaderboardBackground src={LeaderboardBg} />
      {!sectionMode && (
        <BackImg src={ChevronBack} onClick={() => setLeaderboardOpen(false)} />
      )}
      <Heading>Leaderboard</Heading>
      <Tabs>
        <Tab
          active={tab === 'popular'}
          onClick={() => handleTabChange('popular')}
        >
          <img src={Fire} style={{ paddingRight: '4px'}} alt=""/>
          Popular
        </Tab>
        <Tab active={tab === 'new'} onClick={() => handleTabChange('new')}>
          <img src={Trending} style={{ paddingRight: '4px'}} alt=""/>
          New
        </Tab>
        <Tab active={tab === 'scheduled'} onClick={() => handleTabChange('scheduled')}>
          <img src={Clock} style={{ paddingRight: '4px'}} alt=""/>
          Scheduled
        </Tab>
      </Tabs>
      <TopNovels>
        <NovelRank>
          <NovelRank3Img
            src={
              rankData[2]?.image_url ||
              'https://djhonz7dexnot.cloudfront.net/2a1b093e1bb04d6c4dacff914c8e48f684a185e0.png'
            }
          />

          <Star3Img src={Star3} />
          <AuthorName>{rankData[2]?.author_name || 'Stay Tuned'}</AuthorName>
          <NovelName>
            {rankData[2]?.book_title
              ? handleBookTitle(rankData[2]?.book_title)
              : ''}
          </NovelName>
          <StatsDiv>
            <WordsDiv>
              <h5>
                {rankData[2]?.total_words
                  ? numFormatter(rankData[2]?.total_words)
                  : '-'}
              </h5>
              <h6>words</h6>
            </WordsDiv>
            <ViewsDiv>
              <h5>
                {tab === 'scheduled' ? rankData[2]?.publish_count || '-' : rankData[2]?.total_plays
                  ? numFormatter(rankData[2]?.total_plays)
                  : '-'}
              </h5>
              <h6>{tab === 'scheduled' ? 'days' : 'views'}</h6>
            </ViewsDiv>
          </StatsDiv>
        </NovelRank>
        <NovelRank>
          <CrownImg src={Crown} />
          <NovelRank1Img
            src={
              rankData[0]?.image_url ||
              'https://djhonz7dexnot.cloudfront.net/2a1b093e1bb04d6c4dacff914c8e48f684a185e0.png'
            }
          />
          <Star1Img src={Star1} />
          <AuthorName>{rankData[0]?.author_name || 'Stay Tuned'}</AuthorName>
          <NovelName>
            {rankData[0]?.book_title
              ? handleBookTitle(rankData[0]?.book_title)
              : ''}
          </NovelName>
          <StatsDiv>
            <WordsDiv>
              <h5>
                {rankData[0]?.total_words
                  ? numFormatter(rankData[0]?.total_words)
                  : '-'}
              </h5>
              <h6>words</h6>
            </WordsDiv>
            <ViewsDiv>
              <h5>
                {tab === 'scheduled' ? rankData[0]?.publish_count || '-' : rankData[0]?.total_plays
                  ? numFormatter(rankData[0]?.total_plays)
                  : '-'}
              </h5>
              <h6>{tab === 'scheduled' ? 'days' : 'views'}</h6>
            </ViewsDiv>
          </StatsDiv>
        </NovelRank>
        <NovelRank>
          <NovelRank2Img
            src={
              rankData[1]?.image_url ||
              'https://djhonz7dexnot.cloudfront.net/2a1b093e1bb04d6c4dacff914c8e48f684a185e0.png'
            }
          />
          <Star2Img src={Star2} />
          <AuthorName>{rankData[1]?.author_name || 'Stay Tuned'}</AuthorName>
          <NovelName>
            {rankData[1]?.book_title
              ? handleBookTitle(rankData[1]?.book_title)
              : ''}
          </NovelName>
          <StatsDiv>
            <WordsDiv>
              <h5>
                {rankData[1]?.total_words
                  ? numFormatter(rankData[1]?.total_words)
                  : '-'}
              </h5>
              <h6>words</h6>
            </WordsDiv>
            <ViewsDiv>
              <h5>
                {tab === 'scheduled' ? rankData[1]?.publish_count || '-' : rankData[1]?.total_plays
                  ? numFormatter(rankData[1]?.total_plays)
                  : '-'}
              </h5>
              <h6>{tab === 'scheduled' ? 'days' : 'views'}</h6>
            </ViewsDiv>
          </StatsDiv>
        </NovelRank>
      </TopNovels>
      {sectionMode && myRank.author_name && (
        <UserNovel>
          <StarImg>
            <img src={EmptyStar} alt=""/>
            <p>{handleShowRank(myRank)}</p>
          </StarImg>
          <UserNovelImg src={myRank?.image_url} />
          <UserNovelName>
            {tab === 'new' && <NewTag>NEW</NewTag>}
            <h5>{myRank?.author_name}</h5>
            <h6>{myRank?.book_title}</h6>
          </UserNovelName>
          <WordsDiv>
            <h5>{numFormatter(myRank?.total_words)}</h5>
            <h6>words</h6>
          </WordsDiv>
          <ViewsDiv>
            <h5>{numFormatter(myRank?.total_plays)}</h5>
            <h6>{tab === 'scheduled' ? 'days' : 'views'}</h6>
          </ViewsDiv>
        </UserNovel>
      )}
      {!seeAllRankings && (
        <SeeAllrankings onClick={handleSeeAllRanking}>
          See all rankings <img src={ChevronRight} alt=""/>
        </SeeAllrankings>
      )}
      {seeAllRankings && (
        <AllRankings>
          {tab === 'popular' && (
            <RankingTabs>
              <RankingTab
                active={durationTab === 'last_7_days'}
                onClick={() => handleDurationTabChange('last_7_days')}
              >
                Last 7 Days
              </RankingTab>
              <RankingTab
                active={durationTab === 'last_30_days'}
                onClick={() => handleDurationTabChange('last_30_days')}
              >
                Month
              </RankingTab>
              <RankingTab
                active={durationTab === 'all_time'}
                onClick={() => handleDurationTabChange('all_time')}
              >
                All Time
              </RankingTab>
            </RankingTabs>
          )}
          {rankData.map((entry) => (
            <SingleRank>
              <StarImg>
                <img src={EmptyStar} alt=""/>
                <p>{handleShowRank(entry) || '-'}</p>
              </StarImg>
              <UserNovelImg
                src={
                  entry?.image_url ||
                  'https://djhonz7dexnot.cloudfront.net/2a1b093e1bb04d6c4dacff914c8e48f684a185e0.png'
                }
              />
              <SingleRankDetails>
                <h5>{entry?.author_name || 'Stay Tuned'}</h5>
                <h6>{entry?.book_title}</h6>
              </SingleRankDetails>
              <SingleRankWords>
                <h5>
                  {entry?.total_words ? numFormatter(entry?.total_words) : '-'}
                </h5>
                <h6>words</h6>
              </SingleRankWords>
              <SingleRankViews>
                <h5>
                  {tab === 'scheduled' ? entry?.publish_count || '-' : entry?.total_plays ? numFormatter(entry?.total_plays) : '-'}
                </h5>
                <h6>{tab === 'scheduled' ? 'days' : 'views'}</h6>
              </SingleRankViews>
            </SingleRank>
          ))}
          {myRank.author_name && (
            <SingleRank myRank>
              <StarImg>
                <img src={EmptyStar} alt=""/>
                <p>{handleShowRank(myRank) || '-'}</p>
              </StarImg>
              <UserNovelImg src={myRank.image_url} />
              <SingleRankDetails>
                <h5>{myRank.author_name}</h5>
                <h6>{myRank.book_title}</h6>
              </SingleRankDetails>
              <SingleRankWords>
                <h5>{numFormatter(myRank.total_words)}</h5>
                <h6>words</h6>
              </SingleRankWords>
              <SingleRankViews>
                <h5>{tab === 'scheduled' ? myRank?.publish_count || '-' : myRank?.total_plays ? numFormatter(myRank?.total_plays) : '-'}</h5>
                <h6>{tab === 'scheduled' ? 'days' : 'views'}</h6>
              </SingleRankViews>
            </SingleRank>
          )}
        </AllRankings>
      )}
      {seeAllRankings && (
        <DisclaimerAndTips>
          <Disclaimer>
            <DisclaimerHeading>
              <img src={CircleExclamation} alt=""/>
              Disclaimer
            </DisclaimerHeading>
            <HandleDisclaimerAndTips text={contestData?.extra_info?.leaderboard_tips?.[tab].disclaimer} />
          </Disclaimer>
          <Tips>
            <TipsHeading>
              <img src={Academy} alt=""/>
              Tips for getting higher rank
            </TipsHeading>
            <HandleDisclaimerAndTips text={contestData?.extra_info?.leaderboard_tips?.[tab].tips} />
          </Tips>
        </DisclaimerAndTips>
      )}
    </LeaderboardSection>
  )
}

export default LeaderBoard